// File-kind glyphs for the explorer and search rows. Real lucide icons only,
// no hand-drawn SVG, so they sit identically to the rest of the chrome and
// track the theme via currentColor. The kind drives both the glyph and the
// accent color (a .sl contract is the one thing we tint with the accent).

import { Braces, FileCode2, FileText, Folder, FolderOpen, type LucideProps } from "lucide-react";
import type { JSX } from "react";
import type { VFile } from "../store";

export type FileKind = "seal" | "json" | "plain" | "folder";

export function kindOf(file: VFile): FileKind {
  if (file.language === "seal") return "seal";
  if (file.language === "json") return "json";
  return "plain";
}

const ROW_ICON: LucideProps = { size: 14, strokeWidth: 1.75 };

/** The leading glyph for a tree/search row, sized for a 22px row. */
export function FileGlyph({ kind, open }: { kind: FileKind; open?: boolean }): JSX.Element {
  if (kind === "seal") return <FileCode2 {...ROW_ICON} />;
  if (kind === "json") return <Braces {...ROW_ICON} />;
  if (kind === "folder") return open ? <FolderOpen {...ROW_ICON} /> : <Folder {...ROW_ICON} />;
  return <FileText {...ROW_ICON} />;
}

/** The CSS class that tints a glyph by kind (seal → accent, folder → accent,
 *  json → amber, plain → muted). */
export function glyphClass(kind: FileKind): string {
  return `exp-glyph exp-glyph--${kind}`;
}
